import { MSPanelCanvas } from "../panelcanvas/panelcanvas.js";

/**
 * @class MSPanelTab
 * @extends MSPanelCanvas
 * @classdesc Вкладка (панели)
 * */
export class MSPanelTab extends MSPanelCanvas {

    constructor() {
        super();
        this.z = 0;
    }

    /**
     * Видимость
     * @type {bool}
     */
    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        this.parentElement.setTabVisibility(this.id, this._toBool(this._showElement));
    }
}